import React, { Component } from 'react'
import { Button, message, Modal, Radio } from 'hljd'
import { ALBUM } from '../store'
import style from './style.module.less'

import { getAfterFixUrl } from '@components/Hotel/util'
import { ALBUM_MANAGE_PATH_A } from '@constant'
import { isHunlitang, isOtherHotel, isSpecialDish } from '@util'
import { ALBUM_KIND } from '@components/Hotel/constant'

const { Group } = Radio
const ALBUM_TYPE = {
  APPEARANCE: 'appearance',
  LOBBY: 'lobby',
  // EFFECT: 'effect',
  CELEBRITY: 'celebrity'
}
const ALBUM_KIND_QUERY = {
  [ALBUM_TYPE.APPEARANCE]: ALBUM_KIND.OUTWARD,
  [ALBUM_TYPE.LOBBY]: ALBUM_KIND.HALL,
  [ALBUM_TYPE.CELEBRITY]: ALBUM_KIND.CELEBRITY
}
export default class extends Component {
  constructor() {
    super()
    this.state = {
      album_type: ALBUM_TYPE.APPEARANCE,
      checkVideo: null,
      checkPhotos: []
    }
  }

  checkVideo = id => {
    const { checkVideo } = this.state
    this.setState({
      checkVideo: id === checkVideo ? null : id
    })
  }

  changeAlbumType = e => {
    this.setState({
      album_type: e.target.value
    })
  }

  checkPhoto = id => {
    let { checkPhotos } = this.state
    const index = checkPhotos.indexOf(id)

    if (index !== -1) {
      checkPhotos.splice(index, 1)
    } else {
      checkPhotos = [id]
    }

    this.setState({
      checkPhotos: checkPhotos
    })
  }

  afterClose = () => {
    this.setState({
      album_type: ALBUM_TYPE.APPEARANCE,
      checkVideo: null,
      checkPhotos: []
    })
  }

  handleModalOk = () => {
    const { onModalOk, medias, type } = this.props
    const { checkVideo, checkPhotos } = this.state

    if ((type === ALBUM.VIDEO && !medias) || medias.length < 1) {
      return message.warning('暂无视频可供添加')
    }

    let video = null
    let photos = []
    if (type === ALBUM.VIDEO) {
      video = medias.find(video => video.id === checkVideo)
    } else {
      for (const key in medias) {
        if (medias.hasOwnProperty(key)) {
          if (medias[key] && medias[key].length > 0) {
            photos = photos.concat(
              medias[key].filter(photo => checkPhotos.includes(photo.id))
            )
          }
        }
      }
    }

    if (!video && type === ALBUM.VIDEO) {
      message.warning('请选择视频添加')
      return
    }

    if (photos.length === 0 && type === ALBUM.PHOTO) {
      message.warning('请选择照片添加')
      return
    }

    onModalOk(video, photos)
  }

  render() {
    const { visible, type, medias } = this.props
    const { checkVideo, checkPhotos, album_type } = this.state
    return (
      <div>
        <Modal
          onOk={this.handleModalOk}
          className={style.modal}
          visible={visible}
          title={type === ALBUM.VIDEO ? '添加视频' : '添加照片'}
          width={800}
          afterClose={this.afterClose}
          {...this.props}
        >
          {type === ALBUM.PHOTO && (
            <div>
              <Group
                value={album_type}
                className={style.group}
                onChange={this.changeAlbumType}
              >
                <Radio.Button
                  value={ALBUM_TYPE.APPEARANCE}
                  className={style.button}
                >
                  外观环境
                </Radio.Button>
                {/* 酒店类型除四星和五星酒店外，显示大堂和打卡点*/}
                {(isSpecialDish() || isOtherHotel() || isHunlitang()) && (
                  <Radio.Button
                    value={ALBUM_TYPE.LOBBY}
                    className={style.button}
                  >
                    大堂
                  </Radio.Button>
                )}
                {isHunlitang() && (
                  <Radio.Button
                    value={ALBUM_TYPE.CELEBRITY}
                    className={style.button}
                  >
                    网红打卡点
                  </Radio.Button>
                )}
              </Group>
              <div className={style.cards}>
                {medias && medias[album_type] ? (
                  medias[album_type].map(photo => (
                    <div
                      className={style.photo}
                      key={photo.id}
                      onClick={() => this.checkPhoto(photo.id)}
                    >
                      <img src={getAfterFixUrl(photo.url)} />
                      {checkPhotos.includes(photo.id) ? (
                        <i
                          className={`iconfont icon-ziyuan-copy ${style.check}`}
                        />
                      ) : (
                        <div className={style.uncheck} />
                      )}
                    </div>
                  ))
                ) : (
                  <div className={style.default}>
                    <img
                      width={200}
                      height={200}
                      src="https://qnm.hunliji.com/camel-e9420f88-1376-474c-9b37-a64bf1f416d1.png"
                      alt="暂无图片"
                    />
                    <div style={{ marginTop: 24 }}>
                      相册暂无图片，请在相册管理添加图片
                    </div>
                    <Button
                      style={{ marginTop: 17 }}
                      href={
                        ALBUM_MANAGE_PATH_A +
                        '?activeKey=' +
                        ALBUM_KIND_QUERY[album_type]
                      }
                    >
                      去相册管理
                    </Button>
                  </div>
                )}
              </div>
            </div>
          )}

          {type === ALBUM.VIDEO && (
            <div className={style.cards}>
              {medias ? (
                medias.map(video => (
                  <div
                    className={style.video}
                    key={video.persistentId}
                    onClick={() => this.checkVideo(video.id)}
                  >
                    <img src={getAfterFixUrl(video.cover_path)} />
                    {video.id == checkVideo ? (
                      <i
                        className={`iconfont icon-ziyuan-copy ${style.check}`}
                      />
                    ) : (
                      <div className={style.uncheck} />
                    )}
                  </div>
                ))
              ) : (
                <div className={style.default} style={{ marginTop: 20 }}>
                  请在相册管理添加添加视频
                </div>
              )}
            </div>
          )}
        </Modal>
      </div>
    )
  }
}
